import Address from "@/models/address";

export class businessUserRegister{
    constructor() {
        this.commercial=true;
        this.company = new company();
        this.firstName=null;
        this.lastName=null;
        this.email=null;
        this.phoneNumber=null;
        this.password=null;
        this.privacy=null;

    }
}

export class company{
    constructor() {
        this.id=null;
        this.userId=null;
        this.name=null;
        this.legalForm=null;
        this.uStIdNr=null;
        this.address=new Address();
    }
}